import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { ClientComponent } from './client/client.component';
import { UsersComponent } from './users/users.component';
import { AddEditUserComponent } from './users/add-edit-user/add-edit-user.component';
import { RolesComponent } from './roles/roles.component';

import { AppMaterialModule } from 'app/app-material.module';
import { AdminRoutes } from './admin.routing';
import { SurvaleCommonModule } from 'app/components/survale-common/survale-common.module';
import { AddEditRoleComponent } from './add-edit-role/add-edit-role.component';
import { AssignAdminComponent } from './assign-admin/assign-admin.component';
import { ClientSettingsComponent } from './client/client-settings/client-settings.component';
import { EmailSettingsComponent } from './client/email-settings/email-settings.component';
import { ImmediateSettingsComponent } from './client/immediate-settings/immediate-settings.component';
import { ClientClassificationComponent } from './client/client-classification/client-classification.component';
import { AddClientDialogComponent } from './client/add-client-dialog/add-client-dialog.component';
import { ClientIndexWeightsComponent } from './client/client-index-weights/client-index-weights.component';
import { GdprLogComponent } from './gdpr-log/gdpr-log.component';
import { GdprComponent } from './gdpr/gdpr.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { TwoFaCodeComponent } from './users/two-fa-code/two-fa-code.component';
import { SetPasswordComponent } from './users/set-password/set-password.component';
import { QRCodeComponent } from 'angularx-qrcode';
import { ClientIpWhitelistComponent } from './client/client-ip-whitelist/client-ip-whitelist.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { FileUploadModule } from 'ng2-file-upload';
import { MomentModule } from 'ngx-moment';
import { ApiCallLogComponent } from './api-call-log/api-call-log.component';
import { ApiCalllogDetailsDialogComponent } from './api-calllog-details-dialog/api-calllog-details-dialog.component';
// import { AddSamlSSODialogComponent } from './client/add-saml-sso-dialog/add-saml-sso-dialog.component';
import { OtherClientSettingsComponent } from './client/other-client-settings/other-client-settings.component';
import { SftpAccessComponent } from './sftp-access/sftp-access.component';
import { EmbeddedQuestionsComponent } from './embedded-questions/embedded-questions.component';
import { AddEditQuestionDialogComponent } from './embedded-questions/dialogs/add-edit-question-dialog.component';
import { AiPolicyComponent } from './client/ai-policy/ai-policy.component';
import { SsoSettingsComponent } from './client/sso-settings/sso-settings.component';
import { AiFeedbackComponent } from './ai-feedback/ai-feedback.component';
import { ClientEmailConfigComponent } from './client/client-email-config/client-email-config.component';
import { QuestionSetsComponent } from './client/question-sets/question-sets.component';
import { HMPortalCustomFieldsComponent } from './client/hm-portal-custom-fields/hm-portal-custom-fields.component';
import { FilterGroupsComponent } from './filter-groups/filter-groups.component';
import { FilterGroupDialogComponent } from './filter-groups/filter-group-dialog/filter-group-dialog.component';
import { FilterGroupValuesDialogComponent } from './filter-groups/filter-group-values-dialog/filter-group-values-dialog.component';
import { FilterGroupLogsDialogComponent } from './filter-groups/filter-group-logs-dialog/filter-group-logs-dialog.component';
import { FilterGroupsService } from '@services/filter-groups.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild(AdminRoutes),
    FlexLayoutModule,
    AppMaterialModule,
    SurvaleCommonModule,
    NgxDatatableModule,
    QRCodeComponent,
    NgxMatSelectSearchModule,
    FileUploadModule,
    MomentModule
  ],
  declarations: [
    UsersComponent,
    ClientComponent,
    AddEditUserComponent,
    RolesComponent,
    AddEditRoleComponent,
    AssignAdminComponent,
    ClientSettingsComponent,
    EmailSettingsComponent,
    ImmediateSettingsComponent,
    ClientClassificationComponent,
    AddClientDialogComponent,
    // AddSamlSSODialogComponent,
    ClientIndexWeightsComponent,
    GdprLogComponent,
    GdprComponent,
    TwoFaCodeComponent,
    ClientIpWhitelistComponent,
    SetPasswordComponent,
    ApiCallLogComponent,
    ApiCalllogDetailsDialogComponent,
    OtherClientSettingsComponent,
    SftpAccessComponent,
    EmbeddedQuestionsComponent,
    AddEditQuestionDialogComponent,
    AiPolicyComponent,
    SsoSettingsComponent,
    AiFeedbackComponent,
    ClientEmailConfigComponent,
    QuestionSetsComponent,
    HMPortalCustomFieldsComponent,
    FilterGroupsComponent,
    FilterGroupDialogComponent,
    FilterGroupValuesDialogComponent,
    FilterGroupLogsDialogComponent,
  ],
  providers: [
    FilterGroupsService
  ]
})

export class AdminModule { }
